// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import type { PropsWithChildren } from "react"
import { RequiredMark } from "./RequiredMark"

interface FieldProps extends PropsWithChildren {
  label: string
  htmlFor: string
  hint?: string
  /** Defaults true — almost every onboarding field is mandatory
   * (ui-ux-spec.md). Pass `false` for the rare genuinely-optional field
   * (e.g. Step4's target weight). */
  required?: boolean
}

/** Labeled field wrapper shared by every onboarding text/number/select input. */
export function Field({ label, htmlFor, hint, required = true, children }: FieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-baseline gap-1">
        <label htmlFor={htmlFor} className="text-sm font-medium text-ink">
          {label}
        </label>
        {required && <RequiredMark />}
      </div>
      {children}
      {hint && <p className="text-xs text-ink-2">{hint}</p>}
    </div>
  )
}
